<template>
  <div class="searchinit">
    <div style="width: min-content">
      <img
        src="@/assets/image/icon/icon-location-not-found.svg"
        alt="icon-location-not-found"
      />
    </div>
    <p class="desc">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'SectionNotFound',
  props: {
    description: String
  },
  data () {
    return {
      xxx: true
    }
  },
  components: {},
  computed: {},
  created () {},
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/vesselSchedule/SectionNotFound.vue